export default __webpack_public_path__ + "static/logo-27f57d26db0cef8466624ac46a7f15ca.png";